module.exports = __webpack_public_path__ + "static/media/6 1 Ordforstaelse Intro.fe7bc0bd.m4a";